import { Backdrop, Grid, useMediaQuery } from '@mui/material';
import { createContext, useEffect, useMemo, useState } from 'react'
import "./IncomeDashboard.css";
import IncomeCompare from './Compare/IncomeCompare';
import BoxSearch from './Year/BoxSearch';
import { FnAxios, FnDialog, IsNullOrUndefined } from 'utilities/utilities';
import { IResultIncomeDashboard } from './Interface/InterfaceIncome';
import IncomeYear from './Year/IncomeYear';
import moment from 'moment';
import axios from 'axios';
import secureLocalStorage from 'react-secure-storage';

export const ProviderIncomeDashboard = createContext(null);


const IncomeDashboard = () => {


    //#region State / Usememo
    const AxiosFn = FnAxios()
    const DialogFn = FnDialog();
    // #endregion
    const matchesUp768 = useMediaQuery('(min-width:768px)');

    const [option, setOption] = useState({
        lstYear: [],
        lstMuseum: [],
    })
    const [isLoading, setIsLoading] = useState(false)

    const [cancelToken, setCancelToken] = useState(null);

    const [arrYear, setArrYear] = useState([])
    const [arrMonth, setArrMonth] = useState([])
    const [arrMuseum, setArrMuseum] = useState([])
    const [isCheckYear, setIsCheckYear] = useState(false)
    const [rYear, setrYear] = useState(parseInt(moment().format('YYYY')))
    const [objCompare, setObjCompare] = useState<IResultIncomeDashboard>({
        lstCompareCard: [],
        lstCompareGraphStackLine: [],
        lstCompareMonthActual: [],
        lstCompareMonthPlan: [],
        lstCompareTwoLevel: [],
        lstMuseum: [],
        lstMuseumTable: [],
    })

    const [objYear, setObjYear] = useState({
        nYear: 0,
        nPlanInYear: 0,
        nActualInYear: 0,
        rationActulPlan: 0,
        nTotalExpectInYear: 0,
        lstPiePlanSeries: [],
        lstYearTypeIncome: [],
        lstYearTwoLevel: [],
        lstPlanActualExpect: [],
        lstTableYear: [],
        lstMuseumBarLine: [],
        lstMuseumTicket: [],
    })

    useEffect(() => {
        const myParamsSerializer = (params) => {
            const serializedParams = Object.keys(params)
                .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
                .join('&');

            return serializedParams;
        };
        let source = null;
        const GetDashboardIncome = async () => {
            try {
                if (cancelToken) {
                    setIsLoading(false)
                    cancelToken.cancel();
                    setCancelToken(null);
                }

                source = axios.CancelToken.source();
                setCancelToken(source);

                const authToken = secureLocalStorage.getItem(`${process.env.REACT_APP_JWT_KEY}`);
                const ConfigJwt = {
                    Authorization: IsNullOrUndefined(authToken) ? "" : `Bearer ${authToken}`,
                    Accept: "application/json",
                    "Content-Type": "application/json"
                };

                const baseUrl = process.env.REACT_APP_API_URL;
                const sPathApi = `${baseUrl}api/IncomeDashboard/GetDashboardIncome`;
                const url = new URL(sPathApi, window.location.href);
                const sNewPath = url.origin + url.pathname + url.search;

                setIsLoading(true)
                await axios.get(sNewPath, {
                    headers: ConfigJwt,
                    params: {
                        isYear: isCheckYear,
                        nYear: rYear ?? 0,
                        arrYear: (arrYear || []).join("^"),
                        arrMuseum: (arrMuseum || []).join("^"),
                        arrMonth: (arrMonth || []).join("^"),
                    },
                    cancelToken: source.token,
                    paramsSerializer: myParamsSerializer
                })
                    .then((response) => {
                        setIsLoading(false)
                        let objResult = response.data.objResult;
                        if (!objResult) {
                            setObjYear(value => (
                                {
                                    ...value,
                                    nPlanInYear: 0,
                                    nActualInYear: 0,
                                    rationActulPlan: 0,
                                    nTotalExpectInYear: 0,
                                    lstPiePlanSeries: [],
                                    lstYearTypeIncome: [],
                                    lstYearTwoLevel: [],
                                    lstPlanActualExpect: [],
                                    lstTableYear: [],
                                    lstMuseumBarLine: [],
                                    lstMuseumTicket: [],
                                }))
                            setObjCompare(value => ({
                                ...value,
                                lstCompareCard: [],
                                lstCompareGraphStackLine: [],
                                lstCompareMonthActual: [],
                                lstCompareMonthPlan: [],
                                lstCompareTwoLevel: [],
                                lstMuseum: [],
                                lstMuseumTable: [],
                            }))
                            return;
                        }

                        if (isCheckYear) {
                            setObjYear(value => ({
                                ...value,
                                nYear: objResult.nYear,
                                nPlanInYear: objResult.nPlanInYear,
                                nActualInYear: objResult.nActualInYear,
                                rationActulPlan: objResult.rationActulPlan,
                                nTotalExpectInYear: objResult.nTotalExpectInYear,
                                lstPiePlanSeries: objResult.lstPiePlanSeries,
                                lstYearTypeIncome: objResult.lstYearTypeIncome,
                                lstYearTwoLevel: objResult.lstYearTwoLevel,
                                lstPlanActualExpect: objResult.lstPlanActualExpect,
                                lstTableYear: objResult.lstTableYear,
                                lstMuseumBarLine: objResult.lstMuseumBarLine,
                                lstMuseumTicket: objResult.lstMuseumTicket,
                            }))
                            return;
                        }
                        setObjCompare(value => ({
                            ...value,
                            lstCompareCard: objResult.lstCompareCard,
                            lstCompareGraphStackLine: objResult.lstCompareGraphStackLine,
                            lstCompareMonthActual: objResult.lstCompareMonthActual,
                            lstCompareMonthPlan: objResult.lstCompareMonthPlan,
                            lstCompareTwoLevel: objResult.lstCompareTwoLevel,
                            lstMuseum: objResult.lstMuseum,
                            lstMuseumTable: objResult.lstMuseumTable,
                        }))

                    })
                    .catch((error) => {
                        if (axios.isCancel(error)) return;
                    });
            } catch (error) {
                if (axios.isCancel(error)) return;
            }
        };

        GetDashboardIncome();

        return () => {
            if (source) {
                source.cancel();
            }
            if (cancelToken) {
                cancelToken.cancel();
            }
        };
    }, [arrMonth, arrMuseum, arrYear, isCheckYear, rYear]);

    const GetInitIncomeDashboard = () => {
        DialogFn.BlockUI();
        let objParam = {};
        AxiosFn.Get(`IncomeDashboard/GetInitIncomeDashboard`, objParam, (result) => {
            DialogFn.UnBlockUI();
            let objResult = result.objResult;
            let arrYearOption = objResult.arrDefaultYear.map(item => (item.value))
            let arrMuseumId = objResult.lstMuseum.map(item => (item.value))

            setrYear(parseInt(moment().format('YYYY')))
            setArrYear(arrYearOption)
            setArrMuseum(arrMuseumId)
            setArrMonth(["1", "2", "3", "4", "5", "6", "7", "8", "9", "10", "11", "12"])
            setOption(value => ({
                ...value,
                lstYear: objResult.arrYear,
                lstMuseum: objResult.lstMuseum,
            }))

        }, null, () => DialogFn.UnBlockUI());
    };

    const objActualProvider = useMemo(() => (
        {
            option,
            objCompare,
            objYear,
            arrYear,
            setArrYear,
            arrMonth,
            setArrMonth,
            arrMuseum,
            setArrMuseum,
            isCheckYear,
            setIsCheckYear,
            rYear,
            setrYear
        }
    ), [option, objCompare, objYear, arrYear, arrMonth, arrMuseum, isCheckYear, rYear]);

    useEffect(() => {
        window.scrollTo(0, 0);
        GetInitIncomeDashboard();
    }, [])


    return (
        <>
            <ProviderIncomeDashboard.Provider value={objActualProvider} >
                <div style={{ position: "relative", display: 'contents' }}>
                    <div style={{ position: "absolute", left: "10px", top: "56px" }}>
                        <BoxSearch />
                    </div>
                    <Grid container spacing={2} style={{ padding: "2%" ,marginTop:matchesUp768 ? "" :"2%" }}>
                        {
                            isCheckYear ?
                                <Grid item xs={12} >
                                    <IncomeYear />
                                </Grid>
                                :
                                <Grid item xs={12} >
                                    <IncomeCompare />
                                </Grid>
                        }
                    </Grid>
                </div>
            </ProviderIncomeDashboard.Provider>
            <Backdrop
                sx={{
                    zIndex: 10000,
                    backgroundColor: "rgba(0, 0, 0, 0.21)",
                }}
                open={isLoading}
                key={"Backdrop"}
                id="Backdrop"
            >
                <div id="page">
                    <div id="container">
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="ring"></div>
                        <div id="h3">กำลังโหลด</div>
                    </div>
                </div>
            </Backdrop>
        </>
    )
}

export default IncomeDashboard